import React from "react";
import PolicyPrivacy from "../components/PrivacyPolicy/PrivacyPolicy";
import LegalLayout from "../components/legal/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title={
        <>
          ClearBadge{"\u2122"} <span className="legal-title-gradient">Privacy Policy</span>
        </>
      }
      intro="Learn how ClearBadge\u2122 collects, uses, and protects information across our directory, verification tools, digital business cards, and trust sessions."
      eyebrow="Compliance & Trust"
    >
      <PolicyPrivacy />
    </LegalLayout>
  );
}
